<template lang="pug">
  div.account-login
    el-form(:model="ruleForm",
      :rules="rules",
      ref="login")
      el-form-item(prop="phone")
        el-input(v-model="ruleForm.phone", placeholder="请输入手机号", @keydown.enter.native="validator")
      el-form-item(prop="password")
        el-input(v-model="ruleForm.password", type="password", placeholder="请输入密码", @keydown.enter.native="validator")
    div.remember
      el-checkbox(v-model="remember") 记住我的账号
      a(@click="$emit('toComponent', 'forget')") 忘记密码？
    button.submit(:disabled="disabled", @click.prevent="login") 登录
    div.foot
      span 还没账号？
      a(@click="$emit('toComponent', 'register')") 立即注册
</template>

<script>
import _ from 'lodash'
export default {
  name: 'AccountLogin',
  data () {
    let validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      again: false,
      remember: false,
      disabled: true,
      ruleForm: {
        phone: '',
        password: ''
      },
      rules: {
        phone: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    ruleForm: {
      deep: true,
      handler (val) {
        if (_.compact(Object.values(val)).length === Object.keys(val).length || this.again) {
          this.again = true
          this.$refs.login.validate((valid) => {
            this.disabled = !valid
          })
        }
      }
    }
  },
  methods: {
    validator () {
      this.$refs.login.validate((valid) => {
        if (valid) {
          this.login()
        }
      })
    },
    login () {
      let data = this.ruleForm
      this.$store.dispatch('UserLogin', data)
        .then(res => {
          this.$router.push({
            name: 'EventIndex'
          })
        })
        .catch(err => {
          console.log(err)
          // this.errors.add('password', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .account-login{
    margin: 0 32px;
    a{
      color: #3989cb;
      cursor: pointer;
    }
    .remember{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      & /deep/ .el-checkbox__label{
        font-size: 12px;
        color: #999;
      }
    }
    .submit{
      margin-top: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #3989cb;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      font-size: 14px;
      color: #fff;
      &[disabled] {
        background-color: #d5d6d9;
        cursor: not-allowed;
      }
    }
    .foot{
      margin: 40px 0 20px;
      text-align: right;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/AccountLogin.vue